import api from './config';

export function fetchConfig() {
  return api('/siteconfig/');
}
